import * as React from 'react';
import { sendGAEvent } from 'app/util';

const styles = require('./index.pcss');

export const MyData = () => {
    return (
        <section className={ styles.wrap }>
            {/* 철지난 PR 기사 내용 제거 */}
        </section>
    );
};
